import { Renderer } from "@unseenco/taxi";
import { isDEVMODE, viewStorage } from "../_globals";
import WknPlyr from "../modules/wkn-plyr";
import WknSwiper from "../modules/wkn-swiper";
import IndustryProgress from "../modules/industry-progress";
import OurWorkProcess from "../modules/our-work-process";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// import Anchors from '../modules/anchors'
import FlippingCards from "../modules/flipping-cards";
import OurWorkSchema from "../modules/our-work-schema";
import MeasureImpactAccordion from "../modules/measure-impact-accordion";
import OurJourneyTimeline from "../modules/our-journey-timeline";
import Compass from "../modules/compass";
import ToolsAndResources from "../modules/tools-and-resources";

export default class DefaultPageRenderer extends Renderer {
  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener("DOMContentLoaded", onDOMContentLoaded);
      this.onEnter();
      console.log("about-us page renderer loaded");
    };

    document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
  }

  onEnter() {
    console.log("our-work page renderer loaded");
    this.DOM = {
      plyrs: viewStorage.current.querySelectorAll(".plyr__container"),
      ourProcessSection: viewStorage.current.querySelector(".section--process"),
      mainAreasSection: viewStorage.current.querySelector(
        ".section--mainAreas",
      ),
      areasOfActionSwiper: viewStorage.current.querySelector(
        ".section--areas-of-action .swiper",
      ),
      measureImpactSwiper: viewStorage.current.querySelector(
        ".section--measure-impact .swiper",
      ),
      industryProgressSection: viewStorage.current.querySelector(
        ".section--industry-progress",
      ),
      toolsAndResourcesSection: viewStorage.current.querySelector(
        ".section--tools-and-ressources",
      ),
      ourWorkSchema: viewStorage.current.querySelector(".OurWorkSchema"),
      measureImpactCards: viewStorage.current.querySelectorAll(
        ".measure-impact-card",
      ),
      ourJourneyTimeline: viewStorage.current.querySelector(
        ".our-journey__timeline",
      ),
      compassSection: viewStorage.current.querySelector(".compass"),
    };

    this.init();
  }

  init() {
    const {
      plyrs = null,
      ourProcessSection = null,
      mainAreasSection = null,
      industryProgressSection = null,
      areasOfActionSwiper = null,
      measureImpactSwiper = null,
      toolsAndResourcesSection = null,
      ourWorkSchema = null,
      measureImpactCards = null,
      ourJourneyTimeline = null,
      compassSection = null,
    } = this.DOM;

    this.plyrModules = [];
    if (plyrs && plyrs.length)
      plyrs.forEach((item) => this.plyrModules.push(new WknPlyr(item)));
    if (ourProcessSection)
      this.ourWorkProcessModule = new OurWorkProcess(ourProcessSection);
    if (mainAreasSection)
      this.flippingCards = new FlippingCards(mainAreasSection);
    if (industryProgressSection)
      this.IndustryProgressModule = new IndustryProgress(
        industryProgressSection,
      );
    if (areasOfActionSwiper)
      this.areasOfActionSwiperModule = new WknSwiper(areasOfActionSwiper, {
        slidesPerView: "auto",
      });
    if (measureImpactSwiper)
      this.measureImpactSwiperModule = new WknSwiper(measureImpactSwiper, {
        slidesPerView: "auto",
      });
    if (ourWorkSchema)
      this.ourWorkSchemaModule = new OurWorkSchema(ourWorkSchema);

    // Initialize accordion for each measure-impact-card
    if (measureImpactCards && measureImpactCards.length > 0) {
      console.log(
        "OurWork: Found",
        measureImpactCards.length,
        "measure impact cards",
      );
      this.accordionModules = Array.from(measureImpactCards).map(
        (card) => new MeasureImpactAccordion(card),
      );
    }

    // Our Journey Timeline
    if (ourJourneyTimeline) {
      console.log("OurJourneyTimeline: Initializing module...");
      this.ourJourneyTimelineModule = new OurJourneyTimeline(
        ourJourneyTimeline,
      );
    }

    // Compass
    console.log('OurWork - compassSection found?', compassSection)
    if (compassSection) {
      console.log('OurWork - Initializing Compass module...')
      this.compass = new Compass(compassSection)
    } else {
      console.warn('OurWork - compassSection not found, cannot initialize Compass')
    }

    if (toolsAndResourcesSection)
      this.toolsAndResources = new ToolsAndResources(toolsAndResourcesSection);
  }

  onLeaveCompleted() {
    this.plyrModules &&
      this.plyrModules.length &&
      this.plyrModules.forEach((item) => item.destroy());
    this.ourWorkProcessModule && this.ourWorkProcessModule.destroy();
    this.flippingCards && this.flippingCards.destroy();
    this.areasOfActionSwiperModule &&
      this.measureImpactSwiperModule &&
      this.areasOfActionSwiperModule.destroy();
    this.measureImpactSwiperModule && this.measureImpactSwiperModule.destroy();
    this.mySwiper && this.mySwiper.destroy();
    this.ourWorkSchemaModule && this.ourWorkSchemaModule.destroy();

    // Destroy accordion modules
    if (this.accordionModules && this.accordionModules.length > 0) {
      this.accordionModules.forEach((module) => module.destroy());
    }

    // Destroy our journey timeline
    if (this.ourJourneyTimelineModule && typeof this.ourJourneyTimelineModule.destroy === 'function') {
      this.ourJourneyTimelineModule.destroy();
    }

    // Destroy compass
    this.compass && this.compass.destroy();

    this.toolsAndResources && this.toolsAndResources.destroy();
  }
}
